import {ExceptionError} from '../exception'
import {Request} from '../request'
import {IApiResponse, IApiListResponse} from '../../interface/api-response/api-response'
import {API_PATH} from '../../constants/api-path'
import {ILicense, ILicenseActivate, ILicenseCreate, ILicenseGenerate} from '../../interface/license'
import {IPageOption} from '../../interface/paging/paging'

export class GenerateLicenseService extends Request {
  async request(params: ILicenseGenerate) {
    try {
      const {data} = await this.client
        .post<IApiResponse<any>>(`${API_PATH.LICENSE}/generate`, params)
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
export class CreateLicenseService extends Request {
  async request(payload: ILicenseCreate) {
    const {data} = await this.client.post<IApiResponse<any>>(API_PATH.LICENSE, payload)
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetLicenseService extends Request {
  async request(options: IPageOption) {
    const {data} = await this.client.get<IApiListResponse<ILicense[]>>(API_PATH.LICENSE, {
      params: options,
    })
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class ActivateLicenseService extends Request {
  async request(payload: ILicenseActivate) {
    const {data} = await this.client.post<IApiResponse<any>>(
      `${API_PATH.LICENSE}/active-license`,
      payload
    )
    try {
      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}

export class GetLicenseLogService extends Request {
  async request(params: any) {
    try {
      const {data} = await this.client
        .get<IApiResponse<any>>(`${API_PATH.LICENSE}/get-log/${params.id}`, {params})
        .then((d) => d)

      return data
    } catch (error: any) {
      throw new ExceptionError(error.response.data)
    }
  }
}
